import { cn } from '@/legacy-src/lib/utils'

import { getTranslate } from '../../utilities/i18n'
import { useFormError } from './hooks/useFormError'

type ErrorMessageProps = {
  readonly name: string
  readonly className?: string
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ name, className }) => {
  const { t } = getTranslate()
  const error = useFormError(name)

  if (error === undefined) {
    return null
  }
  return (
    <div className={cn('error__field', className)}>
      <span>{t(`${error.message}`)}</span>
    </div>
  )
}

export default ErrorMessage
